/**
 * Local colour accents for the Magic Capture prototype.
 * Structural colours come from the llama theme; these cover prototype-only
 * surfaces (camera viewfinder, shutter, AI-hint chip) that have no token yet.
 */
export const palette = {
  cream: '#faf6ee',
  ink: '#1c1c1e',
  forest: '#0e3b2e',
  shutterOrange: '#e0662e',
  lavender: '#e9e4f6',
  lavenderInk: '#4a3d78',
  softYellow: '#fdf3d0',
  alertRed: '#b3261e',
  mutedText: '#6b6b6d',
  divider: '#e6e0d4',
};
